/**
 * @generated SignedSource<<4876cfc43ff07ca4e3b2ec10a7936551>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type legacyLockMyGrantSubtypeQuery$variables = {
  accessToken: string;
};
export type legacyLockMyGrantSubtypeQuery$data = {
  readonly anonymousUtilizationGrant: {
    readonly reservation: {
      readonly subtype: {
        readonly __typename: string;
      };
    };
  };
};
export type legacyLockMyGrantSubtypeQuery = {
  response: legacyLockMyGrantSubtypeQuery$data;
  variables: legacyLockMyGrantSubtypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessToken"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accessToken",
        "variableName": "accessToken"
      }
    ],
    "concreteType": "UtilizationGrant",
    "kind": "LinkedField",
    "name": "anonymousUtilizationGrant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LockReservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "subtype",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "legacyLockMyGrantSubtypeQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "legacyLockMyGrantSubtypeQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "c478bef562c772ffbcdc41526691cf7f",
    "id": null,
    "metadata": {},
    "name": "legacyLockMyGrantSubtypeQuery",
    "operationKind": "query",
    "text": "query legacyLockMyGrantSubtypeQuery(\n  $accessToken: String!\n) {\n  anonymousUtilizationGrant(accessToken: $accessToken) {\n    reservation {\n      subtype {\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a6e375a26ffe3f9807d11f885c95bf4b";

export default node;
